import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { currencyFormat } from '../../../../../../../utils/Helper'
import { SharedCampaignContext } from '../../../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function MediaAction({ action }) {
  const { campaign } = useContext(SharedCampaignContext)

  return (
    <tr className="dark:border-b dark:border-rb-dark-mode-lighter">
      <td className="p-2 text-xs text-center align-middle font-bold dark:text-white">
        <div className="flex items-center justify-between">
          <p className="">
            {action.name}
          </p>
        </div>
      </td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserFollowerCPM.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserImpressionCPM.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 pr-3 text-xs align-middle font-bold w-[100px] dark:text-white">{action.impression}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{action.buyout ? 'Yes' : 'No'}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.buyoutAdvertiserPrice.toFixed(2), campaign.currency_symbol)}</td>
    </tr>
  )
})